import { useTranslation, withTranslation } from 'react-i18next';
import TextInput from '../../components/common/form/TextInput';
import React, { useRef, useState } from 'react';
import PasswordInput from '../../components/common/form/PasswordInput';
import { useEffect } from 'react';
import PageTitle from '../../common/components/PageTitle';
import { authenticate } from './services/AuthenticationService';
import { useAuthentication } from 'common/contexts/Authentication';
import { useFlashMessages } from '../../common/contexts/FlashMessages';
import HttpStatusError from 'common/errors/HttpStatusError';
import { StatusCodes } from 'http-status-codes';
import { Redirect } from 'react-router-dom';

const alerts = {
  'sign-in-failed': (t) => ({
    variant: 'danger',
    text: (e) => {
      if (e instanceof HttpStatusError && e.httpStatus === StatusCodes.UNAUTHORIZED) {
        return t('messages.errors.logInFailed.invalidCredentials');
      }
      return t('messages.errors.logInFailed.networkError');
    },
  })
};

const UserRedirectAfterLogin = function ({
  authenticated = false
}) {

  if (!authenticated) {
    return null;
  }

  return <Redirect
    to={{
      pathname: '/',
      state: { referrer: '/login' }
    }}
  />;
}

const Login = ({ t }) => {
  const authentication = useAuthentication();
  const flashMessages = useFlashMessages();
  const formRef = useRef();

  const [userAuthDetails, setUserAuthDetails] = useState(() => {
    const authenticated = authentication.isAuthenticated();

    return {
      authenticated,
      ...authentication.currentUser
    }
  });

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {

    if (!formRef.current.checkValidity()) {
      return;
    }

    e.preventDefault();

    try {
      const user = await authenticate(username, password);
      authentication.setCurrentUser(user);
      setUserAuthDetails({ userAuthDetails, ...{ authenticated: true, ...user } });
    } catch (e) {
      flashMessages.addFlashMessage(alerts['sign-in-failed'](t), e);
    }
  };

  return (
    <section>
      <PageTitle t={t} />

      <div className="row">
        <div className="col-1 col-sm-4"></div>
        <div className="col-10 col-sm-4">
          <form validate ref={formRef}>

            <div className="mb-3">
              <label htmlFor="username" className="form-label">{t('userManagement:user.username')}</label>
              <input type="text" className="form-control" id="username" value={username} onChange={(e) => setUsername(e.target.value)} required autoFocus={true}/>
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">{t('userManagement:user.password')}</label>
              <input type="password" className="form-control" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required/>
            </div>

            <a onClick={handleLogin} className="btn btn-primary">{t('actions.login')}</a>
          </form>
        </div>
        <div className="col-1 col-sm-4"></div>
      </div>
      <UserRedirectAfterLogin authenticated={userAuthDetails.authenticated} />
    </section>

  )
}

export default withTranslation('login')(Login);
